import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './404.module.scss';
import Heading from '../../components/Typography/Heading/Heading';
import Paragraph from '../../components/Typography/Paragraph/Paragraph';
import { useTranslation } from 'react-i18next';
const Custom404 = () => {
    const { t } = useTranslation();
    return (_jsxs("div", Object.assign({ className: classNames(styles.element) }, { children: [_jsx(Paragraph, { title: 'OOPS!' }), _jsx(Heading, { title: t('not_found') })] })));
};
export default Custom404;
